import { ActionType } from './api/api';
export const AUTH_START_ACTION_CONNECT_UNVERIFIED = ActionType.CONNECT_UNVERIFIED;
export const AUTH_START_ACTION_PASSWORD_RESET = ActionType.PASSWORD_RESET;
export const authStartEmailVariables = (email, visitId, brand, publicKey, fingerprint, actionType, username) => {
    return {
        visitId,
        brand,
        publicKey,
        fingerprint,
        ...(email ? { email } : {}),
        ...(username ? { username } : {}),
        ...(actionType != null ? { actionType } : {})
    };
};
